<template>
	<page>
		<module>
			<div class="order-state flex-between-center">
				<h1>状态{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>
			
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>订单编号：</label>
							<div class="flex-center-cross">
								{{orderDetail.order_number}}
								<a @click="$copy(orderDetail.order_number)">复制单号</a>
							</div>
						</div>
                        <div class="order-info-item flex">
                            <label>下单时间：</label>
                            <div>{{orderDetail.create_date}} <!-- <a>更多</a> --></div>
                        </div>
                        <div class="order-info-item flex">
                            <label>订单备注：</label>
                            <p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
                        </div>
					</dd>
				</dl>

				<dl class="order-info">
					<dt>物流信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>收货人：</label>
							<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
						</div>
						<div class="order-info-item flex">
							<label>收货地址：</label>
							<p>{{orderDetail.receiving_address}}</p>
						</div>
						<div class="order-info-item flex">
							<label>配送方式：</label>
							<p>{{orderDetail.logistics_company_name}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货时间：</label>
							<p>{{orderDetail.send_dates}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货物流：</label>
							<p>{{orderDetail.send_logistics_numbers}}</p>
						</div>
					</dd>
				</dl>
      </div>
		</module>
		
		<module>
			<div class="order-detail">
				<div style="height:20px;"></div>
				<c-table  v-if="orderDetail" :data="productList" :paging="false" border>
					<c-table-column
						label="商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="商品类型"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.platfrom_sku_id!=0" style="color:blue">分销</span>
							<span v-else style="color:#999">自建</span>
						</template>
					</c-table-column>

					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>

					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="成交单价"
					>
						<template v-slot="{data}">
							{{orderDetail.order_type==2?"":"￥"}}
							{{orderDetail.order_type==2?data.product_unit_price:parseFloat(data.product_unit_price).toFixed(2)}}
							{{orderDetail.order_type==2?"积分":""}}
							
							<font style="text-decoration: line-through;color:#999999;" v-if="data.product_unit_price!=data.original_product_price">
								<br/>
                                <!--{{orderDetail.order_type==2?"":"￥"}}-->
                                ￥
								{{orderDetail.order_type==2?data.original_product_price:parseFloat(data.original_product_price).toFixed(2)}}
                                <!--{{orderDetail.order_type==2?"积分":""}}-->
							</font>
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="折扣率"
						width="85"
						v-if="orderDetail.order_type != 2"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_unit_price*data.product_count*100/data.original_product_money).toFixed(2)}}%
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品总额"
					>
						<template v-slot="{data}">
							{{orderDetail.order_type==2?"":"￥"}}
							{{orderDetail.order_type==2?data.product_money:parseFloat(data.product_money).toFixed(2)}}
							{{orderDetail.order_type==2?"积分":""}}
							<font style="text-decoration: line-through;color:#999999;" v-if="data.product_money!=data.original_product_money">
								<br/>
                                <!--{{orderDetail.order_type==2?"":"￥"}}-->
                                ￥
								{{orderDetail.order_type==2?data.original_product_money:parseFloat(data.original_product_money).toFixed(2)}}
                                <!--{{orderDetail.order_type==2?"积分":""}}-->
							</font>
						</template>
					</c-table-column>

                    <c-table-column
                            label="未发退款数"
                    >
                        <template v-slot="{data}">
                            {{data.total_refund_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="已发退货数"
                    >
                        <template v-slot="{data}">
                            {{data.total_return_count}}
                        </template>
                    </c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="已发货数"
						width="80"
					>
						<template v-slot="{data}">
							{{data.send_count}}
						</template>
					</c-table-column>
				</c-table>

				<div class="order-total flex-between-center">
					<div>
                        商品总额 ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}
                    </div>
				</div>
			</div>
		</module>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		components: {
			productInfo
		},
		
		props: {
			orderNumber: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo:'',
				invoiceInfo:'',
				invoiceDate:'',
				realityMoney: 0,
				sendList: [],
				editList: [],
				lastLogisticsCompany: '',
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info:[],
				new_logistics_money: 0,
				old_money: 0,
		        invoice_file_type:'',//开票文件类型
		        invoice_file:'',//发票文件
		        text_msg:'',
                reducedTypeName: {
                    0: '会员卡礼包',
                    1: '优惠券',
                    2: '限时折扣活动优惠',
                    3: '会员等级折扣优惠',
                    4: '砍价活动优惠',
                    5: '抽奖奖品优惠',
                    6: '积分抵扣',
                    7: '秒杀活动优惠',
                    8: '预售活动优惠',
                    9: '拼团活动优惠',
                    10: '特殊价格优惠',
                    99: '订单调价'
                },
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				retailOrderList:[],
				trandferList: [],
				trandferNum: {}
			}
		},
		
		computed: {
			orderState() {
				return {
                    2: '待发货',
                    3: '已' + this.orderDetail.deliver_state + (this.orderDetail.deliver_state=='全部发货' ? '，待确认收货':'，还有部分货品未发'),
                    5: '交易已收货',
                    6: '订单已取消'
                }[this.orderDetail.order_state];
			},
			orderStateWord() {
			  var msg = "";
                if(this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2){
                    msg = "等待买家支付尾款";
                }else{
                    msg = {
                        2: '请尽快发货',
                        3: '',
                        5: '确认收货时间：' + this.orderDetail.confirm_date,
                        6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name:'') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）':'')
                    }[this.orderDetail.order_state];
                }
				return msg;
			}
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
			//获取订单详情数据
			getOrderDetail() {
				this.request({
					url: '/purchase/order/detail',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.reducedList = data.reduced_list;
						this.cusTomList = data.custom_list||[];
						this.cusTomInfo = data.custom_info||{};
						this.invoiceInfo = data.invoice_info;
						this.pack_info = data.pack_info;
						this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money).toFixed(2):(this.orderDetail.product_money  + (this.cusTomInfo.product_price_money||0) + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
						this.retailOrderList = data.retail_order_list||[];
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
			
			h1 {
				font-size: 24px;
			}
		}
		
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				> div {
					.tag {
						border-radius: 2px;
						padding: 0 5px;
						margin-left: 6px;
						line-height: 18px;
						color: #fff;
					}
					
					a {
						margin-left: 6px;
						color: #005CD9;
					}
				}
			}
		}
		
		&-detail {
			padding: 30px 30px 40px;
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				color: var(--color-main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>